// Date 2021-08-02 17:31:47

import sithMesRitaTestTaskList from "@/views/sithMes/rita/SithMesRitaTestTaskList.vue";
import sithMesRitaTestTaskEdit from "@/views/sithMes/rita/SithMesRitaTestTaskEdit.vue";
import sithMesRitaCameraList from "@/views/sithMes/rita/SithMesRitaCameraList";
import sithMesRitaCameraEdit from "@/views/sithMes/rita/SithMesRitaCameraEdit";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
//自定义页面注册
    {
        path: "/sithMes/rita/sithMesRitaTestTaskList",
        name: "sithMesRitaTestTaskList",
        component: sithMesRitaTestTaskList,
        props: (route) => ({prop_inline: route.query.inline, customVuexName: 'manager'}),
        meta: metaObject
    },
    {
        path: "/sithMes/rita/sithMesRitaTestTaskList/customer",
        name: "sithMesRitaTestTaskListCustomer",
        component: sithMesRitaTestTaskList,
        props: (route) => ({prop_inline: route.query.inline, customVuexName: 'customer'}),
        meta: metaObject
    },
    {
        path: "/sithMes/rita/sithMesRitaTestTaskEdit",
        name: "sithMesRitaTestTaskEdit",
        component: sithMesRitaTestTaskEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/rita/sithMesRitaCameraList",
        name: "sithMesRitaCameraList",
        component: sithMesRitaCameraList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/rita/sithMesRitaCameraEdit",
        name: "sithMesRitaCameraEdit",
        component: sithMesRitaCameraEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    }
]
